module.exports = __webpack_public_path__ + "img/202504_02.0652316c.jpg";